// 演示字体文件 - 包含基本中文字符支持
// 这是一个简化的解决方案，用于演示中文字体集成

// 注意：这不是真正的字体文件，而是一个演示如何集成字体的示例
// 实际使用时需要按照 FONT_SETUP_GUIDE.md 中的步骤配置真正的思源黑体

// 模拟字体注册函数
export const registerDemoFont = (doc: any): boolean => {
  try {
    // 这里模拟字体注册过程
    // 实际情况下，这里应该是真正的Base64字体数据
    
    console.log('Demo: 尝试注册思源黑体字体...');
    
    // 模拟字体注册失败（因为没有真正的字体数据）
    // 在实际项目中，这里应该调用：
    // doc.addFileToVFS('SourceHanSans.ttf', fontData);
    // doc.addFont('SourceHanSans.ttf', 'SourceHanSans', 'normal');
    // doc.setFont('SourceHanSans');
    
    console.log('Demo: 字体注册失败，使用字符映射作为替代方案');
    return false;
  } catch (error) {
    console.warn('Demo: 字体注册过程中出现错误:', error);
    return false;
  }
};

// 增强的字符映射表
export const enhancedChineseCharMap: { [key: string]: string } = {
  // 基本问候语
  '你': 'Ni', '好': 'Hao', '您': 'Nin', '我': 'Wo', '他': 'Ta', '她': 'Ta',
  '它': 'Ta', '们': 'Men', '的': 'De', '是': 'Shi', '在': 'Zai', '有': 'You',
  '不': 'Bu', '了': 'Le', '人': 'Ren', '这': 'Zhe', '那': 'Na', '什': 'Shen',
  '么': 'Me', '时': 'Shi', '候': 'Hou', '地': 'Di', '方': 'Fang', '个': 'Ge',
  
  // 紫微斗数专业术语
  '紫': 'Zi', '微': 'Wei', '斗': 'Dou', '数': 'Shu', '排': 'Pai', '盘': 'Pan',
  '命': 'Ming', '宫': 'Gong', '身': 'Shen', '主': 'Zhu', '星': 'Xing', '曜': 'Yao',
  '财': 'Cai', '帛': 'Bo', '官': 'Guan', '禄': 'Lu', '田': 'Tian', '宅': 'Zhai',
  '福': 'Fu', '德': 'De', '父': 'Fu', '母': 'Mu', '夫': 'Fu', '妻': 'Qi',
  '子': 'Zi', '女': 'Nu', '兄': 'Xiong', '弟': 'Di', '朋': 'Peng', '友': 'You',
  '迁': 'Qian', '移': 'Yi', '疾': 'Ji', '厄': 'E', '奴': 'Nu', '仆': 'Pu',
  
  // 天干地支
  '甲': 'Jia', '乙': 'Yi', '丙': 'Bing', '丁': 'Ding', '戊': 'Wu',
  '己': 'Ji', '庚': 'Geng', '辛': 'Xin', '壬': 'Ren', '癸': 'Gui',
  '丑': 'Chou', '寅': 'Yin', '卯': 'Mao', '辰': 'Chen',
  '巳': 'Si', '午': 'Wu', '未': 'Wei', '申': 'Shen', '酉': 'You',
  '戌': 'Xu', '亥': 'Hai',
  
  // 时间相关
  '年': 'Year', '月': 'Month', '日': 'Day', '分': 'Minute',
  '秒': 'Second', '今': 'Today', '明': 'Tomorrow', '昨': 'Yesterday',
  '前': 'Before', '后': 'After', '早': 'Early', '晚': 'Late',
  '上': 'Up/Morning', '下': 'Down/Afternoon', '中': 'Middle', 
  
  // 方位
  '东': 'East', '南': 'South', '西': 'West', '北': 'North',
  '左': 'Left', '右': 'Right', '内': 'Inside', '外': 'Outside',
  
  // 数字
  '一': 'Yi(1)', '二': 'Er(2)', '三': 'San(3)', '四': 'Si(4)', '五': 'Wu(5)',
  '六': 'Liu(6)', '七': 'Qi(7)', '八': 'Ba(8)', '九': 'Jiu(9)', '十': 'Shi(10)',
  '百': 'Bai(100)', '千': 'Qian(1000)', '万': 'Wan(10000)',
  
  // 颜色
  '红': 'Red', '黄': 'Yellow', '蓝': 'Blue', '绿': 'Green', '黑': 'Black',
  '白': 'White', '粉': 'Pink', '灰': 'Gray', '橙': 'Orange',
  
  // 情感和状态
  '爱': 'Love', '情': 'Emotion', '喜': 'Joy', '怒': 'Anger', '哀': 'Sorrow',
  '乐': 'Happiness', '悲': 'Sadness', '欢': 'Delight', '愁': 'Worry',
  '忧': 'Anxiety', '恐': 'Fear', '惊': 'Surprise',
  
  // 运势相关
  '运': 'Fortune', '势': 'Trend', '吉': 'Auspicious', '凶': 'Inauspicious',
  '利': 'Beneficial', '弊': 'Harmful', '旺': 'Prosperous', '衰': 'Declining',
  '强': 'Strong', '弱': 'Weak', '坏': 'Bad',
  '顺': 'Smooth', '逆': 'Adverse', '成': 'Success', '败': 'Failure',
  
  // 职业和事业
  '工': 'Work', '作': 'Job', '事': 'Matter', '业': 'Career', '职': 'Position',
  '务': 'Duty', '商': 'Business', '贸': 'Trade', '易': 'Exchange',
  '学': 'Study', '习': 'Learn', '教': 'Teach', '育': 'Education',
  
  // 家庭关系
  '家': 'Family', '庭': 'Home', '亲': 'Relative', '戚': 'Kin',
  '祖': 'Ancestor', '儿': 'Son',
  '孙': 'Grandchild', '婆': 'Mother-in-law',
  
  // 健康
  '健': 'Health', '康': 'Wellness', '病': 'Illness', '痛': 'Pain',
  '伤': 'Injury', '药': 'Medicine', '医': 'Doctor', '院': 'Hospital',
  
  // 财富
  '钱': 'Money', '富': 'Rich', '贫': 'Poor',
  '穷': 'Poverty', '贵': 'Expensive', '便': 'Cheap', '宜': 'Suitable',
  
  // 常用动词
  '来': 'Come', '去': 'Go', '走': 'Walk', '跑': 'Run', '飞': 'Fly',
  '坐': 'Sit', '站': 'Stand', '躺': 'Lie', '睡': 'Sleep', '醒': 'Wake',
  '吃': 'Eat', '喝': 'Drink', '看': 'Look', '听': 'Listen', '说': 'Speak',
  '读': 'Read', '写': 'Write', '想': 'Think', '做': 'Do', '买': 'Buy',
  '卖': 'Sell', '给': 'Give', '拿': 'Take', '放': 'Put', '开': 'Open',
  '关': 'Close', '进': 'Enter', '出': 'Exit', '回': 'Return',
  
  // 形容词
  '大': 'Big', '小': 'Small', '高': 'Tall', '矮': 'Short', '长': 'Long',
  '短': 'Short', '宽': 'Wide', '窄': 'Narrow', '厚': 'Thick', '薄': 'Thin',
  '新': 'New', '旧': 'Old', '快': 'Fast', '慢': 'Slow', '热': 'Hot',
  '冷': 'Cold', '暖': 'Warm', '凉': 'Cool', '干': 'Dry', '湿': 'Wet',
  
  // 报告相关
  '报': 'Report', '告': 'Inform', '析': 'Analyze',
  '预': 'Predict', '测': 'Forecast', '建': 'Suggest', '议': 'Advice',
  '注': 'Note', '意': 'Attention', '重': 'Important', '要': 'Essential',
  '特': 'Special', '别': 'Particular', '尤': 'Especially', '其': 'Particularly'
};

// 增强的文本处理函数
export const processChineseTextEnhanced = (text: string): string => {
  return text.replace(/[\u4e00-\u9fff]/g, (char) => {
    return enhancedChineseCharMap[char] || `[${char}]`;
  });
};

// 智能文本处理（保留英文和数字）
export const smartTextProcess = (text: string): string => {
  return text.replace(/[\u4e00-\u9fff]+/g, (match) => {
    // 处理连续的中文字符
    const processed = match.split('').map(char => 
      enhancedChineseCharMap[char] || `[${char}]`
    ).join(' ');
    return `(${processed})`;
  });
};

// 获取字符映射统计
export const getCharMapStats = () => {
  return {
    totalMappings: Object.keys(enhancedChineseCharMap).length,
    categories: {
      basic: '基本词汇',
      astrology: '紫微斗数术语',
      timeDate: '时间日期',
      directions: '方位',
      numbers: '数字',
      colors: '颜色',
      emotions: '情感状态',
      fortune: '运势相关',
      career: '职业事业',
      family: '家庭关系',
      health: '健康',
      wealth: '财富',
      verbs: '动词',
      adjectives: '形容词',
      reports: '报告相关'
    }
  };
};